import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';

// TODO: refactor as component so we can have better control of the div elements and then fix background issue
@Directive({
  selector: '[overflowShadow]',
})
export class OverflowShadowDirective
  implements OnInit, AfterViewInit, OnDestroy {
  private _destroyed: Subject<boolean> = new Subject<boolean>();
  private _scrollElement: Subject<any> = new Subject<any>();
  private _el: any;

  constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {}

  ngOnInit() {
    this._el = this._elementRef.nativeElement;

    this._renderer.setStyle(this._el, 'transition', 'box-shadow 500ms');

    // add/remove overflow shadows on scroll
    this._scrollElement
      .asObservable()
      .pipe(
        debounceTime(300),
        filter((x) => !!x),
        takeUntil(this._destroyed)
      )
      .subscribe((targetEl) => this.setOverflowShadows(targetEl));
  }

  ngAfterViewInit() {
    this._scrollElement.next(this._el);
  }

  @HostListener('scroll', ['$event'])
  scrollHandler(event) {
    this._scrollElement.next(event.target);
  }

  @HostListener('window:resize')
  resizeHandler() {
    this._scrollElement.next(this._el);
  }

  setOverflowShadows(targetEl: any) {
    const scrollTop: number = targetEl.scrollTop;
    const scrollHeight: number = targetEl.scrollHeight;
    const clientHeight: number = targetEl.clientHeight;
    const hasScroll: boolean = scrollHeight > clientHeight;
    const scrollAtTop: boolean = scrollTop === 0;
    const scrollAtBottom: boolean = scrollHeight === scrollTop + clientHeight;
    const boxShadow = [];

    if (hasScroll && !scrollAtTop) {
      boxShadow.push('inset 0px 5px 5px -5px #b9b9c4'); // $grey
    }

    if (hasScroll && !scrollAtBottom) {
      boxShadow.push('inset 0px -5px 5px -5px #b9b9c4'); // $grey
    }

    this._renderer.setStyle(this._el, 'box-shadow', boxShadow.join(','));
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
